export default {
  id: 'vitalSign/BLOOD_GLUCOSE/v1',
  formSchema: {
    title: 'encounter:widget.vitalSigns.bloodGlucose',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'number',
        minimum: 1,
        maximum: 999,
        title: 'encounter:widget.vitalSigns.bloodGlucose'
      }
    },
    iconClass: 'icon-drop',
    measurement: 'mmol/L'
  },
  uiSchema: {
    id001: { 'ui:widget': 'customI18nNumericWidget' },
    'x-customClass': 'vital-signs-widget',
    'x-cancelBtnSize': 'sm',
    'x-saveBtnSize': 'sm'
  }
};
